<template>
  <fieldset>
    <legend>
      {{ label }} <span v-if="fieldRequired">(required)</span>
    </legend>
    <div class="row" :class="{ 'half-width': halfWidth, 'full-width': fullWidth }">
      <div class="column" :class="{ 'half-width': halfWidth, 'full-width': fullWidth }" v-for="(option, index) in options" :key="index">
        <input
          type="radio"
          :id="`${name}-${option.value}`"
          :key="`${name}-${option.value}`"
          :name="name"
          :value="option.value"
          :checked="option.value === value"
          :aria-describedby="hint ? ariaDescID : false"
          :class="{ hasError: errors.has(name) }"
          v-validate="validationRules"
          v-model="chosenValue"
        />
        <label :for="`${name}-${option.value}`" :class="{ 'half-width': halfWidth, 'full-width': fullWidth }" :key="index">
          <span>{{ option.text }}</span>
        </label>
      </div>
    </div>
    <doe-hint :hint="hint" :description="ariaDescID" />
    <doe-error v-if="errors.has(name)" :description="ariaErrorDescID(name)">
      {{ 
        validationRules.is_not==="DC" 
          ? 'You are not part of pilot programme, please use the document upload option instead'
          : errors.first(name) 
      }}
    </doe-error>
  </fieldset>
</template>

<script>
import dynamicValues from "@/mixins/dynamicValues";
import DoeError from "@/components/field/Error";
import DoeHint from "@/components/field/Hint";

export default {
  name: "DoeRadio",
  inject: {
    $validator: "$validator"
  },
  mixins: [dynamicValues],
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    hint: {
      type: [Array, String]
    },
    halfWidth: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    fieldRequired: {
      type: Boolean,
      default: false
    },
    validation: {
      type: [Object, String, Function]
    },
  },
  components: {
    DoeHint,
    DoeError
  },
  data(){
    return {
      isChecked: false
    }
  },
  computed: {
    ariaDescID() {
      return `${this.name}Description`;
    },
    validationRules(){
      return this.getRequiredValue(this.validation);
    },
    chosenValue:{
      get(){
        return this.value;
      },
      set(val){
        this.$emit('input', val);
      }
    }
  },
  methods:{
    ariaErrorDescID(fieldName) {
      return `${fieldName}ErrorDescription`;
    }
  }
};
</script>

<style lang="scss" scoped>
fieldset {
  @apply w-full;
}
legend {
  @apply block font-light font-sans leading-snug max-w-4xl mb-3 subpixel-antialiased text-xl text-black;
}
div.row {
  @apply flex flex-wrap;
}
div.column {
  @apply w-full mb-2;
  max-width: 150px;
}
div.column.half-width {
  max-width: 360px;
}
div.column.full-width {
  @apply max-w-4xl;
}
input {
  @apply absolute overflow-hidden h-0 w-0;
  clip: rect(1px, 1px, 1px, 1px);
}
label {
  @apply cursor-pointer align-middle bg-white border border-blue-900 rounded font-sans subpixel-antialiased text-base text-blue-900 leading-tight inline-block text-center py-2 w-full;
  max-width: 140px;
  &:hover {
    box-shadow: 0 0 0 1px #041e42;
  }
  &:focus {
    @apply border-blue-900;
    box-shadow: 0 0 0 1px #041e42;
    outline: 1px solid #041e42;
    outline-offset: 3px;
  }
}
label.half-width {
  max-width: 350px;
}
label.full-width {
  @apply max-w-4xl;
}
input:checked + label {
  @apply bg-blue-900 font-sans text-base subpixel-antialiased text-white leading-tight;
  box-shadow: 0 0 0 1px #041e42;
}
input:focus + label {
  @apply border-blue-900;
  box-shadow: 0 0 0 1px #041e42;
  outline: 1px solid #041e42;
  outline-offset: 3px;
}
input.hasError {
  border-color: #d0021b;
}
</style>
